import React, { useState } from 'react';
import CustomReactDatePicker from '../../Components/CustomReactDatePicker';

const CustomFields = ({id, type, value, options, onChange, isrequired, radiorequired,disabled }) => {
    const [selectedValues, setSelectedValues] = useState(value || []);
    const Options = options;
    switch (type) {
        case 2: // Long Text
            return <><textarea className="form-control" rows="1" value={value} disabled={disabled}
                onChange={(e) => onChange(e?.target.value)} required={isrequired == 1}></textarea>
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </>
        case 1: // Small Text
        case 3: // Number 
            return <><input className="form-control" min={0} disabled={disabled} type={type === 3 ? 'number' : 'text'}
                value={value ?? ""} onChange={(e) =>
                    type === 3 ?
                        e.target.value.length <= 10 && onChange(e.target.value == "" ? "" : parseInt(e?.target.value?.slice(0, 10)))
                        : onChange(e?.target.value)
                }
                onKeyDown={(e) => {
                    if (["e", "E", "+", "-"]?.includes(e?.key) && type === 3) {
                        e.preventDefault();
                    }
                }}
                required={isrequired == 1} maxLength={type === 1 && 100} />
                <span className="form-text invalid-feedback">
                    *required
                </span></>;
        case 4: // Date
        case 5: // Date & Time
            return <>
                <CustomReactDatePicker isRequired={isrequired == 1} isDisabled={disabled} selectedDate={value} onChangeHandler={onChange} showTimeSelect={type === 5 ? true : false} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </>
        case 6: // Single Selection (using radio buttons)
            return (
                <div>
                    <div className="row">
                        {Options.map((option) => (
                            <div className="col-6">
                                <div className="form-check">
                                    <label className="form-check-label" key={option.value}>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            disabled={disabled}
                                            name={"radio" + option.custom_field_id}
                                            value={option.custom_field_code}
                                            checked={value == option.custom_field_code}
                                            defaultChecked={value === option.custom_field_code}
                                            onClick={(e) => {
                                                if (e.target.value == value) {
                                                    onChange(null); // uncheck
                                                } else {
                                                    onChange(e.target.value); // select
                                                }
                                            }}
                                        />
                                        {option.value}
                                    </label>
                                </div>
                            </div>
                        ))}
                        <span className="Emailinvalid">
                            {radiorequired[id]}
                        </span>
                    </div>
                </div>
            );
        case 7: // Multi Selection (using checkboxes)
            const handleChange = (event) => {
                const newSelection = [...selectedValues];
                if (event.target.checked) {
                    newSelection.push(parseInt(event.target.value));
                } else {
                    newSelection.splice(newSelection.indexOf(parseInt(event.target.value)), 1);
                }
                setSelectedValues(newSelection);
                onChange(newSelection);
            };
            return (
                <div>
                    <div className="row">
                        {Options.map((option) => (
                            <div className="col-6">
                                <label className="form-check-label" key={option.value}>
                                    <input
                                        className="form-check-input me-2"
                                        type="checkbox"
                                        disabled={disabled}
                                        value={option.custom_field_code}
                                        checked={selectedValues.includes(option.custom_field_code)}
                                        onChange={handleChange}
                                    />
                                    {option.value}
                                </label>
                            </div>
                        ))}
                        <span className="Emailinvalid">
                            {radiorequired[id]}
                        </span>
                    </div>
                </div>
            );
        default:
            return null;
    }
};

export default CustomFields;
